import { FC, PropsWithChildren } from "react";
import Container from "../Container";
import ReportParser from "../ReportParser";
import Box from "../Box";

export type DefaultFormParserLayoutProps = {
  html: string;
};

const DefaultFormParserLayout: FC<
  PropsWithChildren<DefaultFormParserLayoutProps>
> = ({ html, children }) => {
  return (
    <Container>
      <Box backgroundColor="white" padding="1.1em 1.8em">
        {children}
      </Box>

      <ReportParser html={html} />
    </Container>
  );
};

export default DefaultFormParserLayout;
